"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var UndoUtil = /** @class */ (function () {
    function UndoUtil() {
        this.name = 'undo';
        this.handler = function (editor) {
            editor.undo();
        };
        this.disable = function (editor) { return !editor.undoable; };
    }
    return UndoUtil;
}());
exports.UndoUtil = UndoUtil;
//# sourceMappingURL=undo-util.js.map